import styled from 'styled-components';

export const StyledCommunityImageBlock = styled.div`
  width: ${({ zoom }) => Math.floor(40 * zoom)}px;
  height: ${({ zoom }) => Math.floor(40 * zoom)}px;
  min-width: ${({ zoom }) => Math.floor(40 * zoom)}px;
  min-height: ${({ zoom }) => Math.floor(40 * zoom)}px;
  border: ${({ frame }) => (frame ? '2px solid #33ABA7' : '0px solid black')};
  background-color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledCommunityImageLetter = styled.span`
  font-size: ${({ zoom }) => Math.floor(13 * zoom)}px;
  line-height: ${({ zoom }) => Math.floor(15 * zoom)}px;
  color: ${({ theme }) => theme.color.baliHai};
  user-select: none;
`;
